/**
 * record-procedures/sql-button-hosts — w których kreatorach układu stoi klocek „Przycisk SQL"
 * i której kartotece katalogu procedur odpowiada każdy z nich.
 *
 * Kreator zna kartotekę po slugu modułu systemowego (`contractors`, `purchase_invoices`…), a
 * lista procedur „Na przycisk" pyta o TYP kartoteki z katalogu (`contractor`, `document`…).
 * Dołożenie kolejnej kartoteki = jeden wiersz w `SQL_BUTTON_TARGETS` — `allowedModules` klocka
 * i zapytanie o listę czytają tę samą mapę.
 *
 * Uwaga dla wierszy dokumentów: serwer wymaga `recordClass` (klasa dokumentu, np.
 * `purchase_invoice`) tylko dla typu `document` i zabrania jej dla pozostałych typów.
 */

import type { RecordProcedureButtonOptionsTarget } from './api';

/** Slug modułu systemowego → kartoteka katalogu procedur. */
const SQL_BUTTON_TARGETS: ReadonlyMap<string, RecordProcedureButtonOptionsTarget> = new Map([
  ['contractors', { recordType: 'contractor' }],
  ['contractor_contacts', { recordType: 'contractor_contact' }],
  ['employees', { recordType: 'employee' }],
  ['users', { recordType: 'user' }],
  ['products', { recordType: 'product' }],
  ['tasks', { recordType: 'task' }],
  ['purchase_invoices', { recordType: 'document', recordClass: 'purchase_invoice' }],
  ['sale_invoices', { recordType: 'document', recordClass: 'sale_invoice' }],
  ['contracts', { recordType: 'document', recordClass: 'contract' }],
  ['letters', { recordType: 'document', recordClass: 'letter' }],
  ['commercial', { recordType: 'document', recordClass: 'commercial' }],
  ['internal', { recordType: 'document', recordClass: 'internal' }],
  ['specjalne', { recordType: 'document', recordClass: 'specjalne' }],
]);

/** Slugi modułów, w których paleta kreatora oferuje klocek „Przycisk SQL". */
export const SQL_BUTTON_ALLOWED_MODULES: readonly string[] = [...SQL_BUTTON_TARGETS.keys()];

/**
 * Kartoteka katalogu procedur dla kreatora modułu o danym slugu; `undefined` — moduł bez
 * klocka „Przycisk SQL" (albo kreator bez znajomości modułu).
 */
export function sqlButtonTargetForModule(
  moduleSlug: string | undefined,
): RecordProcedureButtonOptionsTarget | undefined {
  return moduleSlug === undefined ? undefined : SQL_BUTTON_TARGETS.get(moduleSlug);
}
